import { render, staticRenderFns } from "./BookingSummaryCard.vue?vue&type=template&id=4362e0f4&scoped=true"
import script from "./BookingSummaryCard.vue?vue&type=script&lang=js"
export * from "./BookingSummaryCard.vue?vue&type=script&lang=js"
import style0 from "./BookingSummaryCard.vue?vue&type=style&index=0&id=4362e0f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4362e0f4",
  null
  
)

export default component.exports